export default __webpack_public_path__ + "static/media/icici.20226cd7.svg";